/* tslint:disable */
/* eslint-disable */
/**
 * OpenAPI definition
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


import { mapValues } from '../runtime';
import type { FreelancerCreationRequest } from './';
import {
    FreelancerCreationRequestFromJSON,
    FreelancerCreationRequestFromJSONTyped,
    FreelancerCreationRequestToJSON,
} from './';
import type { ProjectDetailsCreationRequest } from './';
import {
    ProjectDetailsCreationRequestFromJSON,
    ProjectDetailsCreationRequestFromJSONTyped,
    ProjectDetailsCreationRequestToJSON,
} from './';
import type { SubcontractorCreationRequest } from './';
import {
    SubcontractorCreationRequestFromJSON,
    SubcontractorCreationRequestFromJSONTyped,
    SubcontractorCreationRequestToJSON,
} from './';

/**
 * 
 * @export
 * @interface RepatriationOpportunityCreationRequest
 */
export interface RepatriationOpportunityCreationRequest {
    /**
     * 
     * @type {string}
     * @memberof RepatriationOpportunityCreationRequest
     */
    clientIdentityId: string;
    /**
     * 
     * @type {Array<FreelancerCreationRequest>}
     * @memberof RepatriationOpportunityCreationRequest
     */
    freelancers?: Array<FreelancerCreationRequest>;
    /**
     * 
     * @type {Array<SubcontractorCreationRequest>}
     * @memberof RepatriationOpportunityCreationRequest
     */
    subcontractors?: Array<SubcontractorCreationRequest>;
    /**
     * 
     * @type {ProjectDetailsCreationRequest}
     * @memberof RepatriationOpportunityCreationRequest
     */
    projectDetails: ProjectDetailsCreationRequest;
}

/**
 * Check if a given object implements the RepatriationOpportunityCreationRequest interface.
 */
export function instanceOfRepatriationOpportunityCreationRequest(value: object): value is RepatriationOpportunityCreationRequest {
    if (!('clientIdentityId' in value) || value['clientIdentityId'] === undefined) return false;
    if (!('projectDetails' in value) || value['projectDetails'] === undefined) return false;
    return true;
}

export function RepatriationOpportunityCreationRequestFromJSON(json: any): RepatriationOpportunityCreationRequest {
    return RepatriationOpportunityCreationRequestFromJSONTyped(json, false);
}

export function RepatriationOpportunityCreationRequestFromJSONTyped(json: any, ignoreDiscriminator: boolean): RepatriationOpportunityCreationRequest {
    if (json == null) {
        return json;
    }
    return {
        
        'clientIdentityId': json['clientIdentityId'],
        'freelancers': json['freelancers'] == null ? undefined : ((json['freelancers'] as Array<any>).map(FreelancerCreationRequestFromJSON)),
        'subcontractors': json['subcontractors'] == null ? undefined : ((json['subcontractors'] as Array<any>).map(SubcontractorCreationRequestFromJSON)),
        'projectDetails': ProjectDetailsCreationRequestFromJSON(json['projectDetails']),
    };
}

export function RepatriationOpportunityCreationRequestToJSON(value?: RepatriationOpportunityCreationRequest | null): any {
    if (value == null) {
        return value;
    }
    return {
        
        'clientIdentityId': value['clientIdentityId'],
        'freelancers': value['freelancers'] == null ? undefined : ((value['freelancers'] as Array<any>).map((v) => FreelancerCreationRequestToJSON(v))),
        'subcontractors': value['subcontractors'] == null ? undefined : ((value['subcontractors'] as Array<any>).map((v) => SubcontractorCreationRequestToJSON(v))),
        'projectDetails': ProjectDetailsCreationRequestToJSON(value['projectDetails']),
    };
}

